// These feature gates mirror Business Manager prod PLUS my_lenses

export const featureGates = [
    { key: "WebInterfaceFeatureGating:events_manager_enabled" },
    { key: "WebInterfaceFeatureGating:pixels_page_enabled" },
    { key: "WebInterfaceFeatureGating:product_ads_whitelist" },
    { key: "WebInterfaceFeatureGating:reports_enabled" },
    { key: "WebInterfaceFeatureGating:campaign_lab_split_test_enabled" },
    { key: "WebInterfaceFeatureGating:business_dashboard_enabled" },
    { key: "WebInterfaceFeatureGating:profile_manager_whitelist" },
    { key: "WebInterfaceFeatureGating:creator_marketplace_enabled" },
    { key: "WebInterfaceFeatureGating:camera_kit_enabled" },
    { key: "WebInterfaceFeatureGating:developer_portal_enabled" },
    { key: "WebInterfaceFeatureGating:my_lenses_global_nav_enabled" },
];
